module.exports = __webpack_public_path__ + "img/groupIcon2.6ef4669a.jpg";